var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.showLayout)?_c('member-detail-link',{attrs:{"detailLayout":_vm.detailLayout,"memberData":_vm.memberData}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }